import { MonoAvatarModule } from '../../../shared/directives/mono-avatar/mono-avatar.module';
import { ModalsModule } from '../../../widgets/entry-components/modal/modals.module';
import { SinControllerModule } from './../sin-controller/sin-controller.module';
import { PatientAddComponent } from './../add/patient-add.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '../../../shared/translate/translate.module';
import { PatientPipesModule } from '../pipes/patient-pipes.module';
import { DateControllerModule } from '../../../shared/directives/date-controller/date-controller.module';

@NgModule({
  declarations: [PatientAddComponent],
  imports: [
    PatientPipesModule, CommonModule, IonicModule, FormsModule, ReactiveFormsModule,
    SinControllerModule, ModalsModule, TranslateModule, MonoAvatarModule, DateControllerModule
  ],
  exports: [PatientAddComponent]
})
export class PatientAddModule { }
